import { useForm, useFieldArray } from "react-hook-form";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  AddAuditScoreApproverMaster,
  getApproverListService,
  getAuditScoreMasterList,
} from "../Action";
import Toaster from "../../../common/Toaster";
import LoaderCustom from "../../../common/LoaderCustom";
import { useDispatch } from "react-redux";
import { userDetails } from "../../../../helper";

function AuditScore() {
  const {
    register,
    control,
    reset,
    handleSubmit,
    getValues,
    formState: { errors },
    watch,
    setValue,
  } = useForm({ mode: "onChange", reValidateMode: "onChange" });
  const [approverList, setApproverList] = useState([]);
  const [submitLoading, setSubmitionLoading] = useState(false);
  const dispatch = useDispatch();


  const { fields, append, remove } = useFieldArray({
    control,
    name: "approvalRules",
  });
   const getAuditMasterList = () => {
    setSubmitionLoading(true); // Set loading to true when fetching data starts
    getAuditScoreMasterList()
      .then((res) => {
        const initialApprovalRules =
          res?.result?.data &&
          res?.result?.data?.map((item) => ({
            fromScore: item.auditScoreRangeFrom,
            toScore: item.auditScoreRangeTo,
            approver1: {
              value: item.firstApproverProfileID,
              label: item.firstApproverProfileName,
            },
            approver2: {
              value: item.secondApproverProfileID,
              label: item.secondApproverProfileName,
            },
          }));
        reset({
          ...getValues(),
          approvalRules: initialApprovalRules,
        });

        // Set values for Select components
        initialApprovalRules.forEach((rule, index) => {
          setValue(`approvalRules[${index}].approver1`, rule.approver1);
          setValue(`approvalRules[${index}].approver2`, rule.approver2);
        });

        setSubmitionLoading(false); // Set loading to false after data is fetched
      })
      .catch(() => {
        setSubmitionLoading(false); // Set loading to false if an error occurs during data fetching
      });
  };

  useEffect(() => {
    getAuditMasterList();
    getApproverListService()
      .then((res) => {
        // Assuming res.data contains the list of approvers
        setApproverList(res?.Data?.profileCodes);
      })
      .catch(() => { });
  }, []);

  const validateScores = (fromScore, toScore, index) => {
    if (index > 0) {
      const previousToScore = parseFloat(
        watch(`approvalRules[${index - 1}].toScore`)
      );
      const previousFromScore = parseFloat(
        watch(`approvalRules[${index - 1}].fromScore`)
      );
      if (fromScore !== previousToScore + 1) {
        return "From Score should be one more than the previous To Score";
      }
      if (
        fromScore <= previousToScore ||
        toScore <= previousToScore ||
        fromScore <= previousFromScore ||
        toScore <= previousFromScore
      ) {
        return "Score range should be in ascending order";
      }
    }
    if (toScore - fromScore > 60 || fromScore > 60 || toScore > 60) {
      return "Score range should not exceed 60";
    }
    return true;
  };

  const onSubmit = async (data) => {
    let empId = userDetails();
    setSubmitionLoading(true); // Set loading indicator to true
    try {
      const scoreRanges = data.approvalRules.map((rule) => ({
        AuditScoreRangeFrom: parseFloat(rule.fromScore),
        AuditScoreRangeTo: parseFloat(rule.toScore),
        FirstApproverProfileID: rule.approver1?.value,
        SecondApproverProfileID: rule.approver2?.value,
        EmployeeId: empId?.EmployeeId, // Assuming this is a constant value for all entries
      }));

      // Check ascending order and maximum range
      for (let i = 1; i < scoreRanges.length; i++) {
        if (
          scoreRanges[i].AuditScoreRangeFrom <=
          scoreRanges[i - 1].AuditScoreRangeTo
        ) {

          return;
        }
        if (
          scoreRanges[i].AuditScoreRangeTo -
          scoreRanges[i].AuditScoreRangeFrom >
          60
        ) {

          return;
        }
      }
      // Dispatch action with Redux
      const res = await new Promise((resolve) => {
        dispatch(AddAuditScoreApproverMaster(scoreRanges, resolve));
      });

      if (res && res.IsSuccessful) {
        // Handle successful response
        getAuditMasterList();
        Toaster.success(res?.Data?.Message);
        // Further actions...
      } else {
        // Handle unsuccessful response

      }
    } catch (error) {
      // Handle errors

    } finally {
      setSubmitionLoading(false); // Set loading indicator to false after completion or error
    }
  };

  const handleDeleteRow = (index) => {
    remove(index);
  };

  const handleAddRow = () => {
    append({
      fromScore: "",
      toScore: "",
      approver1: "", // Provide default value here
      approver2: "", // Provide default value here
    });
  };
  // if (submitLoading) {
  //   return <div></div>;
  // }
  return (
    <>
      {submitLoading ? (
        <LoaderCustom customClass={"loader-center"} />
      ) : (
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="pt-4 hl-nsa-review-details"
        >
          <table className="hl-auditScoreTBL w-100">
            <thead>
              <tr>
                <th>From Score<span className="asterisk-required">*</span></th>
                <th>To Score<span className="asterisk-required">*</span></th>
                <th>Approver 1<span className="asterisk-required">*</span></th>
                <th>Approver 2</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {fields.map((field, index) => (
                <tr key={field.id}>
                  <td>
                    <input
                      {...register(`approvalRules[${index}].fromScore`, {
                        required: true,
                        validate: (value) =>
                          validateScores(
                            parseFloat(value),
                            parseFloat(
                              watch(`approvalRules[${index}].toScore`)
                            ),
                            index
                          ),
                      })}
                      type="number"
                      defaultValue={field.fromScore}
                      placeholder="Enter From Score"
                      className="form-control"
                    />
                    {errors?.approvalRules && errors.approvalRules[index] && (
                      <div className="text-help">
                        {errors.approvalRules[index].fromScore && (
                          <>
                            {errors.approvalRules[index].fromScore.message}
                            {errors.approvalRules[index].fromScore.type ===
                              "required" && " Field is required"}
                          </>
                        )}
                      </div>
                    )}
                  </td>
                  <td>
                    <input
                      {...register(`approvalRules[${index}].toScore`, {
                        required: true,
                        validate: (value) =>
                          validateScores(
                            parseFloat(
                              watch(`approvalRules[${index}].fromScore`)
                            ),
                            parseFloat(value),
                            index
                          ),
                      })}
                      type="number"
                      defaultValue={field.toScore}
                      placeholder="Enter To Score"
                      className="form-control"
                    />
                    {errors?.approvalRules && errors.approvalRules[index] && (
                      <div className="text-help">
                        {errors.approvalRules[index].toScore && (
                          <>
                            {errors.approvalRules[index].toScore.message}
                            {errors.approvalRules[index].toScore.type ===
                              "required" && " Field is required"}
                          </>
                        )}
                      </div>
                    )}
                  </td>
                  <td>
                    <Select
                      {...register(`approvalRules[${index}].approver1`, {
                        required: true, // Apply required rule only when no default value is provided
                      })}
                      value={watch(`approvalRules[${index}].approver1`)}
                      onChange={(selectedOption) => {
                        setValue(
                          `approvalRules[${index}].approver1`,
                          selectedOption ? selectedOption : null
                        );
                      }}
                      options={approverList.map((approver) => ({
                        value: approver.Id,
                        label: approver.Name,
                      }))}
                    />
                    {errors?.approvalRules && errors.approvalRules[index] && (
                      <div className="text-help">
                        {errors.approvalRules[index].approver1 && (
                          <>
                            {errors.approvalRules[index].approver1.message}
                            {errors.approvalRules[index].approver1.type ===
                              "required" &&
                              // Check if selected value is not an empty string
                              !getValues(`approvalRules[${index}].approver1`) &&
                              " Field is required"}
                          </>
                        )}
                      </div>
                    )}
                  </td>

                  <td>
                    <Select
                      {...register(`approvalRules[${index}].approver2`, {
                        required: false, // Apply required rule only when no default value is provided
                      })}
                      value={watch(`approvalRules[${index}].approver2`)}
                      onChange={(selectedOption) => {
                        setValue(
                          `approvalRules[${index}].approver2`,
                          selectedOption ? selectedOption : null
                        );
                      }}
                      options={approverList.map((approver) => ({
                        value: approver.Id,
                        label: approver.Name,
                      }))}
                    />
                    {errors?.approvalRules && errors.approvalRules[index] && (
                      <div className="text-help">
                        {errors.approvalRules[index].approver2 && (
                          <>
                            {errors.approvalRules[index].approver2.message}
                            {errors.approvalRules[index].approver2.type ===
                              "required" &&
                              // Check if selected value is not an empty string
                              !getValues(`approvalRules[${index}].approver2`) &&
                              " Field is required"}
                          </>
                        )}
                      </div>
                    )}
                  </td>

                  <td className="text-center">
                    {index > 0 && (
                      <button
                        type="button"
                        onClick={() => handleDeleteRow(index)}
                        title="Delete"
                        className="Delete hl-delete-icon"
                      ></button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="text-right">
            <button
              className="save-btn submit-button mr5"
              type="button"
              onClick={handleAddRow}
              title="Add Row"
            >
              <div className="plus"></div>Add
            </button>
            <button type="submit" className="submit-button save-btn">
              <div className="save-icon"></div>Save
            </button>
          </div>
        </form>
      )}
    </>
  );
}

export default AuditScore;
